import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { typedShallowEqual } from "@nxplatform/helpers/helpers";
import { AUTH_CUSTOMER_MODULE_NAME } from "@nxplatform/platform-entities";
import { selectCustomerTokenEntities } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { selectModuleLoaded } from "@nxplatform/store-utils/module-manager/module-manager.slice";
import { useModuleManager } from "@nxplatform/store-utils/module-manager/module-manager.hook";
const useAuthCustomerModuleProvider = () => {
  const { auth, moduleLoaded } = useSelector((state) => ({
    auth: selectCustomerTokenEntities(state),
    moduleLoaded: selectModuleLoaded(state, AUTH_CUSTOMER_MODULE_NAME)
  }), typedShallowEqual);
  const loadedRef = useRef(false);
  const [moduleConfig, setModuleConfig] = useState(null);
  const moduleConfigLength = Object.keys(moduleConfig || {}).length;
  const ready = useModuleManager(moduleConfig, true);
  useEffect(() => {
    if (moduleLoaded) {
      loadedRef.current = moduleLoaded;
      return;
    }
    if (!!auth && !moduleLoaded && !moduleConfigLength) {
      import("@nxplatform/customer/customer.module").then(({ customerModule }) => {
        setModuleConfig(customerModule);
      });
    }
  }, [auth, moduleLoaded, moduleConfigLength]);
  useEffect(() => {
    if (ready) {
      loadedRef.current = ready;
    }
  }, [ready]);
  return loadedRef.current;
};
export {
  useAuthCustomerModuleProvider
};
